import { t } from '@lingui/macro'
import { ErrorBoundary } from '@sentry/react'
import React, { FC } from 'react'

import { BlogItem } from '../../interfaces'
import Background from '../Showcase/Background'
import Title from '../Showcase/Title'
import BlogComponent from './BlogComponent'
import styles from './ChannelBlog.module.css'

const section = 'blogs'

interface Props {
  data: Array<BlogItem>
}

const ChannelBlog: FC<Props> = ({ data }) => {
  const schema = {
    title: t`TOP BLOGS BY DOCTOR`,
    subTitle: t`chosen for your specific needs`,
    actionUrl: '/blogs',
  }

  return (
    <ErrorBoundary fallback={<></>}>
      <div className={styles.marginBottom}>
        <Background styles={styles} />
        <div className={styles.channelBlogWrapper}>
          <div className={styles.channelBlogTitle}>
            <Title schema={schema} section={section} styles={styles} />
          </div>
          <div className={styles.channelBlogWrapperItems}>
            {data?.slice(0, 3).map(item => (
              <BlogComponent key={item.id} item={item} />
            ))}
          </div>
        </div>
      </div>
    </ErrorBoundary>
  )
}

export default ChannelBlog
